import React, { useState, useEffect, useContext, Fragment, useRef } from "react";
import style from "./content_sharing_home.module.css";
import styles from "../../layout.module.css"
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { MdOutlineFileUpload } from "react-icons/md"

const ContentSharingHome = () => {
    const [userId, setUserId] = useState([]);
    const [contentList, setContentList] = useState([]);
    const { auth } = useContext(AuthContext);
    const [pfp, setPfp] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserIds = async () => {
            try {
                const { data } = await axios.get('https://python.umiuni.com:5555/umiuni_content_get_user/?pwd=testing');
                setUserId(data.userid);
            } catch (error) {
                console.error("Error fetching user IDs or processing data:", error);
            }
        };
        fetchUserIds();
        console.log(userId)
    }, [auth]);

    useEffect(() => {
        if (userId.length === 0) return;

        const fetchContent = async () => {
            try {
                const results = await axios.get(`https://python.umiuni.com:5555/umiuni_content_latest_catalog/?pwd=testing`);

                const allData = results.data;
                const sortedData = [...allData].sort((a, b) => userId.indexOf(a.userid) - userId.indexOf(b.userid));

                setContentList(sortedData);
            } catch (error) {
                console.error(error);
            }
        };

        fetchContent();
    }, [userId]);

    useEffect(() => {
        const getPfp = async () => {
            try {
                // Encode the userid
                const encodeResponse = await Promise.all(
                    userId.map(userid => axios.post(
                        "https://umiuni.com:5002/api/user/encode_userid", { userid }, 
                        { headers: { "Content-Type": "application/json" }, maxBodyLength: Infinity }
                    ))
                )
                    
                const encodedId = encodeResponse.map(res => res.data.result);
                console.log(encodedId)

                const results = await Promise.allSettled(
                    encodedId.map(userid => fetch(
                            `${process.env.REACT_APP_API_URL}api/user/get?userid=${userid}`
                        )
                    )
                );

                const jsons = await Promise.all(
                    results.map(res => res.status === 'fulfilled' ? res.value.json().catch(() => null) : Promise.resolve(null))
                );
                const pfpFinal = jsons.map(res => res.avatar || '94NCQ5GiFeXAVwr3alGqY7Zp9xlzpIGu');

                setPfp(pfpFinal);
            } catch (error) {
                console.error(error);
            }
        };
        getPfp();
    }, [userId])


    return (
        <Fragment>
            <div className = {styles.homepageContainer}>
                <div className={style.gallery}>
                    <div className={`${style.card} ${style.addCard}`} onClick={() => navigate('/content_sharing/upload')}><MdOutlineFileUpload className={style.uploadIcon} /></div>
                    {contentList.map((element, i) => (
                    <div key={i} className={style.card} onClick={() => navigate(`/content_sharing/${element.userid}/`)}>
                        {element.photo_location?.endsWith('.pdf') ? (
                            <a href={element.photo_location}>{element.content_name}</a>
                        ) : (
                            <img src={element.photo_location} alt={element.content_name} loading="lazy" />
                        )}

                        {/* Hover overlay */}
                        <div className={style.overlay}>
                            <div className={style.overlayText}>
                                <span className={style.line} title={element.content_name}>{element.content_name}</span>
                                <span className={`${style.line} ${style.sub}`} title={element.text}>{element.text}</span>
                                {pfp[i] && (<img src={`https://oss.umiuni.com/${pfp[i]}`} className={style.avatar}/>)}
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </Fragment>
    );
};

export default ContentSharingHome;
